import { Avatar, type AvatarProps } from "@/components/ui/avatar.tsx";
import { UserIcon } from "@heroicons/react/24/solid";
import type { ComponentType, SVGProps } from "react";
import { cn } from "cn";

export interface PlaceholderAvatarProps {
    size?: AvatarProps["size"];
    className?: string;
    icon?: ComponentType<SVGProps<SVGSVGElement>>;
}

export function PlaceholderAvatar({ size, className, icon: Icon = UserIcon }: PlaceholderAvatarProps) {
    return (
        <span className="relative inline-flex shrink-0 align-middle">
            <Avatar size={size} initials="" alt="" className={cn("bg-secondary text-muted-fg", className)} />
            <Icon aria-hidden="true" className="text-muted-fg pointer-events-none absolute inset-0 m-auto size-[55%]" />
        </span>
    );
}
